import { doc, serverTimestamp, setDoc } from "@firebase/firestore";
import React, { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useAuth, useFirestore } from "reactfire";
import { uuid } from "uuidv4";
import Game from "../interfaces/Game";
import { QuestionRecord } from "../interfaces/GameUser";
import questionData from "../data/questions";
import Question from "../interfaces/Question";

export interface StartProps {}

function getRandom(arr: Question[], n: number) {
	var result: Question[] = new Array(n),
		len = arr.length,
		taken = new Array(len);
	if (n > len) throw new RangeError("getRandom: more elements taken than available");
	while (n--) {
		var x = Math.floor(Math.random() * len);
		result[n] = arr[x in taken ? taken[x] : x];
		taken[x] = --len in taken ? taken[len] : len;
	}
	return result;
}

const Start: React.FC<StartProps> = () => {
	const [isLoading, setIsLoading] = useState(false);

	const firestore = useFirestore();
	const auth = useAuth();
	let navigate = useNavigate();

	const createGame = () => {
		setIsLoading(true);
		if (auth.currentUser?.uid) {
			const docId = uuid();
			const ref = doc(firestore, "games", docId);
			const questionsToAdd = getRandom(questionData, 10);
			const questions: QuestionRecord[] = questionsToAdd.map((q) => ({
				questionId: q.id
			}));
			const data: Game = {
				users: [auth.currentUser.uid],
				status: {
					[auth.currentUser.uid]: {
						completed: false,
						questions,
						name: auth.currentUser.displayName,
						image: auth.currentUser.photoURL
					}
				},

				createdAt: serverTimestamp(),
				createdBy: auth.currentUser.uid
			};
			setDoc(ref, data)
				.then(() => {
					navigate(`/${docId}`);
				})
				.finally(() => {
					setIsLoading(false);
				});
		}
	};

	return (
		<>
			<Card className="get-started">
				<div className="deco">
					<h1 className="display">Ready to Play?</h1>

					<p>
						Let's get started by selecting your favorite holiday tradition from 10 different categories. Then share your game
						with friends and family to see your Christmas Compatibility Score.
					</p>

					<Button disabled={isLoading} onClick={() => createGame()}>
						<div className="deco">Start Game</div>
					</Button>
				</div>
			</Card>
		</>
	);
};

export default Start;
